import RouteConstant from "@/constant/RouteConstant.js";

const RouteCacheInclude = [
  RouteConstant.MAIN,
  RouteConstant.ASSETS_TRANS_LIST,
  RouteConstant.CARD_APPLY_LIST,
  RouteConstant.CARD_TRANS_LIST,
  RouteConstant.CARD_BILL_LIST,
'/card/trans/list2?cardId=ce273130-ba3d-4662-b3f6-f8796de76ee1'
]

const getExlude = (include) => {
  let keys = Object.keys(RouteConstant)
  keys = keys.filter(key => {
    let res = !include.includes(RouteConstant[key])
    return res
  })
  return keys.map(_ => {
    // return new RegExp(`${ RouteConstant[_]}[${'\\S'}]*`)
    return RouteConstant[_]
  })
}

const RouteCacheExlude = getExlude(RouteCacheInclude)

export {
  RouteCacheExlude,
  RouteCacheInclude
}